import { HelpContent } from '../../../../UI-Lib/Help-Tooltip';

export const RETURN_OVERVIEW_COMPONENT_HELP: HelpContent[] = [];
